import { useUserProfile } from '../libs'

/**
 * Hook to determine if a user only has social sign-in options (no password-based authentication)
 *
 * This hook checks if the user has sign-in options available but none of them include 'PASSWORD',
 * which indicates they can only sign in through social providers (Apple, Google, etc.)
 *
 * @returns boolean - true if user only has social sign-in options, false otherwise
 */
export const useIsSocialSignInOnly = (): boolean => {
  const { data: userData } = useUserProfile()

  return !!(
    userData?.me?.signInOptions &&
    userData.me.signInOptions.length > 0 &&
    !userData.me.signInOptions.includes('PASSWORD')
  )
}
